<template>
    <div class="section">
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
        <b-carousel :arrow-hover="true" :indicator="false">
            <b-carousel-item v-for="slide in slides" :key="slide.id">
                <span class="image">
                    <img :src="slide.image" alt="carousel-slide">
                </span>
            </b-carousel-item>
        </b-carousel>
    </div>
</template>

<script>
import { getHandler } from '../../../services/http'
export default {
    props:{
        dataUrl:{
            type:String, 
            default:""
        }
    },
    data(){
        return{
            slides:[],
            loading:false,
        }
    },
    methods:{
        async fetchSlides(){
            this.loading=true
            this.slides = await getHandler(this.dataUrl, {error:false, succes:false})
            this.loading = false
        }
    },
    created(){
        this.fetchSlides()
    }
}
</script>

<style lang="scss" scoped>
.image{
    max-height: 500px;
}

</style>